// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","buttonLarge":"Button_buttonLarge__-eGQo","buttonUpper":"Button_buttonUpper__SBb-Q"};